import type { NavItem, Product, ProcessStep, Feature, CaseStudy, Announcement, Document, CooperationMode, ContactInfo, Banner } from '../types'

export const navigation: NavItem[] = [
  { id: 'home', label: '首页', href: '/' },
  { id: 'solutions', label: '解决方案', href: '/solutions' },
  { id: 'products', label: '产品中心', href: '/products' },
  { id: 'announcement', label: '公告/文档', href: '/announcement' },
  // { id: 'docs', label: '文档中心', href: '/docs' },
  { id: 'about', label: '关于我们', href: '/about' },
  // { id: 'cooperation', label: '商务合作', href: '/cooperation' },
]

export const supplyChainProcess: ProcessStep[] = [
  { id: 1, title: '学校下单', description: '学校通过客户端提交采购需求，系统智能匹配最优供货商', icon: 'shopping-cart' },
  { id: 2, title: '供货商采买', description: '供货商接收订单，进行原材料采购与质量把控', icon: 'store' },
  { id: 3, title: '入库管理', description: '原材料入库检验，建立批次追溯档案', icon: 'package' },
  { id: 4, title: '备货处理', description: '根据订单需求进行分拣备货，确保数量准确', icon: 'clipboard-list' },
  { id: 5, title: '智能分拣', description: '自动化分拣系统，提高效率减少错误', icon: 'layers' },
  { id: 6, title: '物流运输', description: '冷链物流全程监控，保障食品安全', icon: 'truck' },
  { id: 7, title: '学校核验', description: '学校验收货物，核对数量与质量', icon: 'check-circle' },
  { id: 8, title: '学校入库', description: '入库登记，建立库存管理档案', icon: 'archive' },
  { id: 9, title: '出库管理', description: '按需出库，先进先出管理', icon: 'log-out' },
  { id: 10, title: '财务结算', description: '自动生成结算单，支持多种结算方式', icon: 'credit-card' },
]

export const products: Product[] = [
  {
    id: 'school-client',
    title: '学校客户端',
    description: '专为学校食堂管理设计的PC端应用，提供订单管理、库存管理、财务对账等功能',
    icon: 'monitor',
    features: ['订单管理', '库存监控', '财务对账', '数据报表', '权限管理'],
    downloadUrl: '',
    qrCode: '',
  },
  {
    id: 'school-mini',
    title: '学校小程序',
    description: '微信小程序版本，方便学校管理人员随时随地处理业务',
    icon: 'smartphone',
    features: ['移动审批', '实时通知', '扫码溯源', '数据查看', '快捷下单'],
    downloadUrl: '#',
    qrCode: '/images/wechat_code.jpg',
  },
  {
    id: 'supplier-client',
    title: '供货商客户端',
    description: '供货商专用PC端应用，支持订单接收、采购管理、配送调度等功能',
    icon: 'building',
    features: ['订单接收', '采购管理', '配送调度', '财务结算', '库存管理'],
    downloadUrl: '',
    qrCode: '',
  },
  {
    id: 'supplier-mini',
    title: '供货商小程序',
    description: '供货商移动端应用，实时接收订单通知，便捷处理业务',
    icon: 'smartphone',
    features: ['订单提醒', '配送跟踪', '扫码入库', '财务查询', '客户管理'],
    downloadUrl: '#',
    qrCode: '/images/wechat_code.jpg',
  },
  {
    id: 'education-bureau',
    title: '教体局管理客户端',
    description: '教育体育局监管平台，实现区域学校食堂统一监管',
    icon: 'building-2',
    features: ['区域监管', '数据分析', '预警系统', '考核评估', '政策发布'],
    downloadUrl: '',
    qrCode: '',
  },
  {
    id: 'finance-client',
    title: '财务客户端',
    description: '专业财务管理工具，支持多维度财务分析与报表生成',
    icon: 'calculator',
    features: ['财务报表', '成本分析', '预算管理', '发票管理', '审计追踪'],
    downloadUrl: '',
    qrCode: '',
  },
]

export const features: Feature[] = [
  {
    id: 'education-bureau',
    title: '教体局监管平台',
    description: '提升监管效能与决策支持，实现全域数据实时同步、远程巡查与智能预警',
    icon: 'shield-check',
    details: ['一键查看各校采购库存', '信息化监管平台', '大数据分析决策', '溯源追踪'],
  },
  {
    id: 'finance',
    title: '乡镇财务管理',
    description: '规范资金使用与账务处理，实现支付、结算、报销全流程线上化、自动化',
    icon: 'bar-chart-2',
    details: ['全流程线上化自动化', '自动生成合规凭证', '实时可查便于审计', '资金使用透明'],
  },
  {
    id: 'school',
    title: '学校食堂管理',
    description: '优化采购流程与库存管理，智能采购计划、扫码出入库、全链条溯源',
    icon: 'zap',
    details: ['智能采购计划', '扫码出入库', '全链条溯源', '实时库存更新'],
  },
  {
    id: 'supplier',
    title: '供货商协作',
    description: '提升供应效率与协作透明度，在线接单、电子签收、自动对账',
    icon: 'brain',
    details: ['在线接收订单', '电子签收对账', '信息实时同步', '提升结算效率'],
  },
  {
    id: 'traceability',
    title: '全程溯源',
    description: '从源头到餐桌，每一个环节都可追溯，保障食品安全',
    icon: 'scan',
    details: ['二维码溯源', '批次追踪', '检验报告', '物流轨迹'],
  },
  {
    id: 'compliance',
    title: '合规管理',
    description: '符合国家食品安全法规，助力学校规范化管理',
    icon: 'shield-check',
    details: ['证照管理', '检验检测', '台账记录', '审计追溯'],
  },
]

export const caseStudies: CaseStudy[] = [
  {
    id: 'case-1',
    title: '师宗县农村义务教育学生营养改善计划',
    client: '师宗县教育局',
    industry: '教育',
    description: '为全县多所学校提供供应链管理服务，实现食品安全全程可追溯',
    results: [
      { metric: '采购效率', value: '提升60%', improvement: '自动化采购流程' },
      { metric: '食品安全', value: '零事故', improvement: '全程溯源监控' },
      { metric: '成本控制', value: '降低15%', improvement: '智能比价采购' },
    ],
    image: '/images/case_01.png',
  },
  /* {
    id: 'case-2',
    title: '某大型供货商数字化转型',
    client: '某农产品供应商',
    industry: '农业',
    description: '帮助传统供货商实现数字化转型，提升运营效率',
    results: [
      { metric: '订单处理', value: '提升80%', improvement: '自动化订单系统' },
      { metric: '配送时效', value: '缩短30%', improvement: '智能调度系统' },
      { metric: '客户满意度', value: '95%', improvement: '服务质量提升' },
    ],
    image: '/images/case-supplier.jpg',
  }, */
]

export const announcements: Announcement[] = [
  {
    id: 'ann-1',
    title: '书香云库软件介绍',
    summary: '书香云库是一款用于解决当前教育体制下学生膳食改善流程化管理的软件，实现四方协同、数据共享、全程追溯',
    content: '书香云库是一款用于解决当前教育体制下学生膳食改善流程化管理的软件。软件分为客户端（供应商、学校、教体局、财务端）手机端（学校、供应商）和网页端。\n\n一、教体局：提升监管效能与决策支持\n传统流程存在的问题：信息不透明，难以实时掌握各校食堂运营情况；依赖层层上报，数据滞后且易失真；监管手段有限，难以实现全过程追溯与风险预警。\n使用系统软件后的解决效果：实现全域数据实时同步，一键查看各校采购、库存、用餐、财务等情况；建立信息化监管平台，支持远程巡查、智能预警与溯源追踪；依托大数据分析，为营养改善计划优化、资金调配等决策提供科学依据。\n\n二、乡镇财务管理方：规范资金使用与账务处理\n使用系统软件后的解决效果：实现支付、结算、报销全流程线上化、自动化；系统自动生成合规凭证，对接财政系统，确保账实相符；财务数据实时可查，便于审计与监督检查，提升资金使用透明度。\n\n三、学校食堂食品采购方：优化采购流程与库存管理\n使用系统软件后的解决效果：支持智能采购计划，根据食谱与库存自动生成订单；扫码出入库，实时更新库存数据，自动生成台账；全链条溯源体系，食材来源、流转过程一目了然，提升食品安全管控能力。\n\n四、供货商：提升供应效率与协作透明度\n使用系统软件后的解决效果：通过供应商端口在线接单、确认配送，减少沟通误差；电子签收、自动对账，提升结算效率；信息实时同步，增强供应协同性与合作信任。\n\n五、软件信息化综合价值\n"书香云库"以"四方协同、数据共享、全程追溯"为核心，构建从采购、配送、验收到财务结算的一体化数字管理平台，实现流程标准化、数据实时化、监管全程化、安全可追溯的综合效益。\n\n联系人员：13987420608',
    date: '2025-12-01',
    author: '书香云库',
    category: 'notice',
  },
  {
    id: 'ann-2',
    title: '小程序学校端上线',
    summary: '学校端小程序正式上线，为学校食堂管理提供便捷服务，支持移动审批、实时通知、扫码溯源等功能',
    content: '尊敬的用户，我们很高兴地宣布，书香云库学校端小程序已正式上线！\n\n学校端小程序专为学校食堂管理设计，提供以下核心功能：\n\n1. 移动审批：随时随地处理采购申请、入库审批等业务流程\n2. 实时通知：第一时间接收订单状态、库存预警等重要消息\n3. 扫码溯源：扫描食材二维码，快速查看食材来源、检验报告等信息\n4. 数据查看：实时查看采购数据、库存情况、财务报表\n5. 快捷下单：一键下单采购，智能推荐采购数量\n\n使用方式：微信搜索"书香云库学校端"小程序即可使用。\n\n如有任何问题，请联系客服：13987420608',
    date: '2026-03-01',
    author: '产品部',
    category: 'update',
  },
  {
    id: 'ann-3',
    title: '小程序供应商端上线',
    summary: '供应商端小程序正式上线，实现在线接单、配送跟踪、扫码入库等便捷功能',
    content: '尊敬的供应商伙伴，我们很高兴地宣布，书香云库供应商端小程序已正式上线！\n\n供应商端小程序专为供应商业务管理设计，提供以下核心功能：\n\n1. 订单提醒：实时接收学校采购订单，不再错过任何商机\n2. 配送跟踪：记录配送路线、配送状态，提升配送效率\n3. 扫码入库：扫描入库，自动更新库存数据\n4. 财务查询：随时查看对账单、结算状态，资金流向一目了然\n5. 客户管理：维护学校客户关系，提升服务质量\n\n使用方式：微信搜索"书香云库供应商端"小程序即可使用。\n\n如有任何问题，请联系客服：13987420608',
    date: '2026-03-03',
    author: '产品部',
    category: 'update',
  }
]

export const documents: Document[] = [
  {
    id: 'doc-3',
    title: '书香云库软件介绍',
    description: '学校食堂食品安全管理制度范本',
    fileSize: '370 KB',
    fileType: 'DOCX',
    downloadUrl: '/docs/书香云库软件介绍.docx',
    uploadDate: '2026-01-08',
  },
  {
    id: 'doc-1',
    title: '供货商用户操作手册',
    description: '详细介绍系统各功能模块的使用方法',
    fileSize: '2.1 MB',
    fileType: 'DOCX',
    downloadUrl: '/docs/供货商用户操作手册.docx',
    uploadDate: '2026-01-15',
  },
  {
    id: 'doc-2',
    title: '书香云库供货商端全新版本',
    description: '系统API接口说明文档，供开发者参考',
    fileSize: '11.1 MB',
    fileType: 'DOCX',
    downloadUrl: '/docs/书香云库供货商端全新版本.docx',
    uploadDate: '2026-02-20',
  },
  {
    id: 'doc-4',
    title: '书香云库小程序用户操作手册',
    description: '详细介绍小程序各功能模块的使用方法',
    fileSize: '340 KB',
    fileType: 'DOCX',
    downloadUrl: '/docs/书香云库小程序用户操作手册.docx',
    uploadDate: '2026-01-08',
  },
]

export const cooperationModes: CooperationMode[] = [
  {
    id: 'mode-1',
    title: '区域代理',
    description: '成为指定区域的独家代理商，享受区域保护政策',
    benefits: ['区域独家经营权', '技术培训支持', '市场推广支持', '高额返佣'],
    icon: 'map-pin',
  },
  {
    id: 'mode-2',
    title: '渠道合作',
    description: '利用现有渠道资源，推广供应链管理系统',
    benefits: ['灵活的合作方式', '持续收益分成', '品牌授权支持', '客户资源对接'],
    icon: 'users',
  },
  {
    id: 'mode-3',
    title: '技术合作',
    description: '共同开发行业解决方案，实现互利共赢',
    benefits: ['技术资源共享', '联合研发', '知识产权保护', '市场联合推广'],
    icon: 'code',
  },
]

export const contactInfo: ContactInfo = {
  phone: '139 8742 0608',
  // email: 'contact@shuxiang.com',
  address: '云南省',
  wechat: '书香云库',
  workingHours: '周一至周五 9:00-18:00',
}

export const banners: Banner[] = [
  {
    id: 'banner-1',
    title: '书香云库 - 学校膳食管理专家',
    subtitle: '四方协同 · 数据共享 · 全程追溯，构建从采购、配送、验收到财务结算的一体化数字管理平台',
    image: '/images/banner-1.jpg',
    link: '/solutions',
    ctaText: '了解更多',
  },
  {
    id: 'banner-2',
    title: '守护校园食品安全',
    subtitle: '为教体局、学校、供货商、财务四方提供信息化管理解决方案，让数据多跑路、人员少跑腿',
    image: '/images/banner-2.jpg',
    link: '/products',
    ctaText: '立即体验',
  },
  {
    id: 'banner-3',
    title: '诚邀合作伙伴',
    subtitle: '携手共建书香云库生态，共创校园食品安全美好未来',
    image: '/images/banner-3.jpg',
    link: '/cooperation',
    ctaText: '立即合作',
  },
]

export const industryPainPoints = [
  {
    id: 'pain-1',
    title: '教体局：信息不透明',
    description: '难以实时掌握各校食堂运营情况，依赖层层上报，数据滞后且易失真',
    icon: 'alert-circle',
  },
  {
    id: 'pain-2',
    title: '财务：手工记账繁琐',
    description: '手工记账对账工作量大易出错，票据管理混乱，资金流向不清晰',
    icon: 'search-x',
  },
  {
    id: 'pain-3',
    title: '学校：采购管理困难',
    description: '采购计划依赖经验，手工登记出入库易出错，食材溯源困难',
    icon: 'scatter',
  },
  {
    id: 'pain-4',
    title: '供货商：协作效率低',
    description: '订单接收依赖电话微信易漏单，送货签收繁琐，对账周期长',
    icon: 'clock',
  },
]

export const solutions = [
  {
    id: 'sol-1',
    title: '教体局：全域监管',
    description: '一键查看各校采购库存，远程巡查智能预警，决策数据实时支撑',
    icon: 'shopping-bag',
  },
  {
    id: 'sol-2',
    title: '财务：自动结算',
    description: '支付结算报销全流程线上化，自动生成合规凭证，账实相符',
    icon: 'scan-line',
  },
  {
    id: 'sol-3',
    title: '学校：智能管理',
    description: '智能采购计划，扫码出入库，全链条溯源，食品安全有保障',
    icon: 'layout-dashboard',
  },
  {
    id: 'sol-4',
    title: '供货商：高效协同',
    description: '在线接单确认配送，电子签收自动对账，信息实时同步',
    icon: 'cpu',
  },
]
